export default __webpack_public_path__ + "static/media/Markup.bdbf2bc2.svg";